(() => {
  'use strict';
  if (window.pinoReviewImagesInit) {
    window.pinoReviewImagesInit();
    return;
  }

  let products={};fetch(new URL('pino-review-products.json',document.currentScript.src)).then(r=>r.ok?r.json():{}).then(data=>{products=data;init();}).catch(()=>{});
  const clean = value => (value||'').replace(/["“”]?Pro["“”]?/g,'').trim();
  const hydrate = root => {
    root.querySelectorAll('a[href*="judge.me/reviews/stores/"]').forEach(a=>{if(a.href.includes('/products/')){const handle=a.href.split('/products/')[1].split(/[?#]/)[0];a.href='/products/'+handle+'#pino-reviews';a.removeAttribute('target');}else{const span=document.createElement('span');span.textContent=a.textContent;a.replaceWith(span);}});
    root.querySelectorAll('.jdgm-carousel-item').forEach(item=>{const image=item.querySelector('.jdgm-carousel-item__product-image');const name=clean(image?.alt);const url=products[name];if(image&&image.alt!==name)image.alt=name;if(!url||item.querySelector('.pino-review-link'))return;const a=document.createElement('a');a.className='pino-review-link';a.textContent='この商品のレビューを見る →';a.href=url+'?judgeme_review_uuid='+encodeURIComponent(item.dataset.reviewId||'')+'#pino-reviews';item.append(a);});
    root.querySelectorAll('img.jdgm-carousel-item__product-image[data-src], img.jdgm-rev__pic-img[data-src]').forEach(image => {
      if (image.getAttribute('src')) return;
      try {
        const source = new URL(image.dataset.src, document.baseURI);
        if (source.protocol !== 'https:' || !['cdn.shopify.com', 'review-images.judgeme.com'].includes(source.hostname)) return;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.src = source.href;
      } catch {
        // Leave invalid third-party image data untouched.
      }
    });
  };

  const init = () => document.querySelectorAll('.pk-judgeme, #pino-reviews').forEach(root => {
    hydrate(root);
    if (root.dataset.pinoImagesReady) return;
    root.dataset.pinoImagesReady = 'true';
    root.addEventListener('click',event=>{const item=event.target.closest('.jdgm-carousel-item');const target=item?.querySelector('.pino-review-link');if(!target)return;event.preventDefault();event.stopImmediatePropagation();location.assign(target.href);},true);
    new MutationObserver(() => hydrate(root)).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'data-src']
    });
  });

  window.pinoReviewImagesInit = init;
  document.addEventListener('shopify:section:load', init);
  init();
})();

